import React from 'react';
import styles from './Button.module.css';

export interface Props {
  type?: string,
  size?: string,
  variant?: string,
  label: string,
  dataCy?: string | undefined,
  icon?: React.ReactNode,
  disabled?: boolean,
  onButtonClick?: (e: React.MouseEvent) => void,
  className?: string,
}

export default function Button({
  type = 'secondary',
  size = 'medium',
  variant = 'fill',
  label = 'Button',
  dataCy = undefined,
  icon = null,
  disabled = false,
  onButtonClick,
  className,
}: Props) {
  const getClass = () => `${styles.button} ${(disabled) ? styles.disabled : styles[type]} ${styles[size]} ${styles[variant]} ${(className) || ''}`;

  return (
    <button
      type="button"
      className={getClass()}
      onClick={onButtonClick}
      disabled={disabled}
      data-cy={dataCy}
    >
      {(icon) && (<span className={styles.icon}> {icon} </span>)}
      {label}
    </button>
  );
}
